<template>
  <div id="fetch" class="fetch-area" v-if="getFetchStatus">
    <div class="fetch-area-wrapper"></div>
  </div>
</template>

<script>
export default {
  name: 'FetchArea',
  computed: {
    getFetchStatus() {
      return this.$store.state.fetch;
    },
  },
};

</script>

<style scoped>
  .fetch-area {
    width: 100%;
    height: 16px;
    top: 0;
    left: 0;
    position: fixed;
    padding: 5px 30px;
    animation: fadeIn .3s backwards;
    z-index: 9000;
    display: inline-flex;
    animation-delay: .15s;
  }

  .fetch-area-wrapper {
    flex: 1;
    background-color: white;
    border-radius: 3px;
    overflow: hidden;
    position: relative;
  }

  .fetch-area-wrapper:before {
    content: "";
    display: block;
    width: 120%;
    height: 100%;
    background-color: var(--color-primary-ligth);
    position: absolute;
    animation: fetchProgress 1.8s infinite linear;
  }
</style>
